function areArraysEqual(arr1: any[], arr2: any[]) {
  if (arr1 === arr2) {
    return true;
  }

  if (
    !Array.isArray(arr1) ||
    !Array.isArray(arr2)
  ) {
    return false;
  }

  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] === arr2[i]) {
      continue;
    }

    if (
      Array.isArray(arr1[i]) &&
      Array.isArray(arr2[i]) &&
      areArraysEqual(arr1[i], arr2[i])
    ) {
      continue;
    }

    if (
      arr1[i] &&
      arr2[i] &&
      typeof arr1[i] === 'object' &&
      typeof arr2[i] === 'object' &&
      !Array.isArray(arr1[i]) &&
      !Array.isArray(arr2[i]) &&
      areObjectsEqual(arr1[i], arr2[i])
    ) {
      continue;
    }

    return false;
  }

  return true;
}

export function areObjectsEqual(obj1: Record<any, any>, obj2: Record<any, any>) {
  if (obj1 === obj2) {
    return true;
  }

  if (
    !obj1 ||
    typeof obj1 !== 'object' ||
    !obj2 ||
    typeof obj2 !== 'object'
  ) {
    return false;
  }

  if (
    Array.isArray(obj1) &&
    Array.isArray(obj2)
  ) {
    return areArraysEqual(obj1, obj2);
  }

  if (
    Array.isArray(obj1) ||
    Array.isArray(obj2)
  ) {
    return false;
  }

  const obj1Keys = Object.keys(obj1);
  const obj2Keys = Object.keys(obj2);

  if (!areArraysEqual(obj1Keys, obj2Keys)) {
    return false;
  }

  const obj1Values = obj1Keys.map(k => obj1[k]);
  const obj2Values = obj2Keys.map(k => obj2[k]);

  return areArraysEqual(obj1Values, obj2Values);
}
